import { FC, useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./style.scss";
import backForDocEmpty from "@/src/assets/admissionOfficePage/back-for-doc-empty.png";
import backForDegreeDocumentsPdf from "@/src/assets/admissionOfficePage/back-for-degree-documents.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

/** Matches `.degree-pdf-document` padding so shadow is not clipped. */
const DEGREE_PDF_SHADOW_INSET_PX = 14;

interface IAOPPrev {
  showDegreePdf: boolean;
}

const AOPPrev: FC<IAOPPrev> = ({ showDegreePdf }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [numPages, setNumPages] = useState(0);
  const [pageWidth, setPageWidth] = useState(0);

  useEffect(() => {
    if (!showDegreePdf) {
      setNumPages(0);
      return;
    }

    const el = containerRef.current;
    if (!el) return;

    const updateWidth = () => {
      setPageWidth(Math.max(0, Math.floor(el.clientWidth - DEGREE_PDF_SHADOW_INSET_PX * 2)));
    };

    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(el);
    return () => observer.disconnect();
  }, [showDegreePdf]);

  return (
    <div className="admission-office-prev-wrapper">
      <div
        className={`admission-office-prev switzerland degree-documents${showDegreePdf ? " has-pdf" : ""}`}
        ref={containerRef}
      >
        {!showDegreePdf ? (
          <img className="admission-office-prev-background" src={backForDocEmpty} alt="" />
        ) : (
          <Document
            file={backForDegreeDocumentsPdf}
            loading={null}
            onLoadSuccess={({ numPages: nextNumPages }) => setNumPages(nextNumPages)}
            className="degree-pdf-document"
          >
            {pageWidth > 0 &&
              Array.from({ length: numPages }, (_, index) => (
                <div className="degree-pdf-page" key={`degree-page-${index + 1}`}>
                  <Page
                    pageNumber={index + 1}
                    width={pageWidth}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                </div>
              ))}
          </Document>
        )}
      </div>
    </div>
  );
};

export default AOPPrev;
